import React, { useEffect, useState } from "react";
import Fotter from "./Fotter";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import Cookies from "js-cookie";
import { BASE_URL } from "../Pages/Config";
import { formatDistanceToNow } from "date-fns";

export default function SettingQuestionAnswer() {
  const [othersQuestions, setOthersQuestions] = useState([]);
  const [userQuestions, setUserQuestions] = useState([]);
  const [loadingOthers, setLoadingOthers] = useState(true);
  const [loadingUser, setLoadingUser] = useState(true);

  const [activeTab, setActiveTab] = useState("others"); // default "others"

  // Pick dataset based on tab
  const filteredQuestions =
    activeTab === "you" ? userQuestions : othersQuestions;
  const isLoading = activeTab === "you" ? loadingUser : loadingOthers;

  // Skeleton loader component
  const Skeleton = () => (
    <div
      className="notifiy"
      style={{
        width: "100%",
        padding: "10px",
        display: "flex",
        marginBottom: "15px",
      }}
    >
      <div
        style={{
          width: "10%",
          height: "50px",
          borderRadius: "50%",
          background: "#e0e0e0",
          animation: "pulse 1.5s infinite",
        }}
      />
      <div style={{ flex: 1, marginLeft: "10px" }}>
        <div
          style={{
            width: "60%",
            height: "14px",
            background: "#e0e0e0",
            marginBottom: "8px",
            animation: "pulse 1.5s infinite",
          }}
        />
        <div
          style={{
            width: "40%",
            height: "12px",
            background: "#e0e0e0",
            animation: "pulse 1.5s infinite",
          }}
        />
      </div>
    </div>
  );

  // Fetch "asked by others"
  useEffect(() => {
    const fetchQuestions = async () => {
      const user_id = Cookies.get("user_id");
      setLoadingOthers(true);
      try {
        const res = await fetch(
          `${BASE_URL}/get_question.php?user_id=${user_id}&t=${Date.now()}`
        );
        const text = await res.text();
        //     console.log("Others Raw response:", text);
        const data = JSON.parse(text);
        if (data.success) {
          setOthersQuestions(data.data);
        }
      } catch (err) {
        console.error("Invalid JSON:", err);
      } finally {
        setLoadingOthers(false);
      }
    };
    fetchQuestions();
  }, []);

  // Fetch "asked by you"
  useEffect(() => {
    const fetchQuestionsAskByUser = async () => {
      const user_id = Cookies.get("user_id");
      setLoadingUser(true);
      try {
        const res = await fetch(
          `${BASE_URL}/get_question.php?user_id=${user_id}&type=user_ask&t=${Date.now()}`
        );
        const text = await res.text();
        //   console.log("User Ask Raw response:", text);
        const data = JSON.parse(text);
        if (data.success) {
          setUserQuestions(data.data);
        }
      } catch (err) {
        console.error("Invalid JSON:", err);
      } finally {
        setLoadingUser(false);
      }
    };
    fetchQuestionsAskByUser();
  }, []);

  return (
    <>
      <Navbar />
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>
                <p>QUESTION & ANSWER</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-sm-12 col-md-8 col-lg-9 col-xl-9">
              <div className="setting-info" style={{background:"transparent"}}>
                <div className="col-12">
                  {/* Tabs */}
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    <button
                      onClick={() => setActiveTab("others")}
                      style={{
                        padding: "10px",
                        width: "50%",
                        border: "none",
                        background: "transparent",
                        fontWeight: activeTab === "others" ? "bold" : "normal",
                        borderBottom:
                          activeTab === "others"
                            ? "3px solid black"
                            : "0px solid #ffffffff",
                        cursor: "pointer",
                      }}
                    >
                      Asked by Others
                    </button>

                    <button
                      onClick={() => setActiveTab("you")}
                      style={{
                        padding: "10px",
                        width: "50%",
                        border: "none",
                        background: "transparent",
                        fontWeight: activeTab === "you" ? "bold" : "normal",
                        borderBottom:
                          activeTab === "you"
                            ? "3px solid black"
                            : "0px solid #ffffffff",
                        cursor: "pointer",
                      }}
                    >
                      Asked by You
                    </button>
                  </div>

                  {/* Loading skeleton */}
                  {isLoading ? (
                    <>
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                    </>
                  ) : filteredQuestions.length > 0 ? (
                    filteredQuestions.map((item, index) => (
                      <Link
                        key={index}
                        to={
                          activeTab === "you"
                            ? "/question"
                            : `/answer/${item.question_id}`
                        }
                      >
                        <div
                          className="notifiy"
                          style={{ width: "100%", padding: "0px" , background:"#fdfdfd",borderRadius:"10px"}}
                        >
                          <div
                            className="notification-img notify_img"
                            style={{ width: "10%" }}
                          >
                            <span
                              style={{
                                padding: "10px 23px",
                                background: "rgb(237 237 237)",
                                fontWeight: 700,
                                fontSize: "25px",
                                borderRadius: "50%",
                              }}
                            >
                              {item.asked_by?.charAt(0).toUpperCase()}
                            </span>
                          </div>
                          <div
                            className="notify-mass"
                            style={{
                              width: "90%",
                              padding: "5px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              position: "relative"
                            }}
                          >
                            <div className="notify-title notifi_mass_box">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "end",
                                  gap: "5px",
                                }}
                              >
                                <b
                                  style={{
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                  }}
                                >
                                  <Link to={`/detail/${item.question_item_id}`}>
                                    <span>Product Name :</span>{" "}
                                    <span>{item.product_title} </span>
                                  </Link>
                                </b>
                              </div>

                              <p
                                className="timer"
                                style={{ margin: "0", fontSize: "13px" , marginRight:"5px"}}
                              >
                                {formatDistanceToNow(
                                  new Date(item.question_date + "Z"),
                                  {
                                    addSuffix: true,
                                  }
                                ).replace("about ", "")}
                              </p>


                              {activeTab === "you" && Number(item.status) === 0 ?
                                <p
                                  className="question_banned"
                                >

                                  {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                  </svg> */}


                                  Banned By FastTrade
                                </p> : ""}
                            </div>
                            <div
                              className="massage"
                              style={{ justifyContent: "start" }}
                            >
                              <p style={{ margin: "0", fontSize: "12px" }}>
                                <b>Asked by : {item.asked_by}</b>
                                <div>
                                  <b>Question :</b> {item.question}
                                </div>
                              </p>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <img
                      src={`${BASE_URL}/uploads/logo/data_not_found.png`}
                      alt="No Data"
                      style={{
                        width: "100%",
                        height: "450px",
                        objectFit: "contain",
                        mixBlendMode: "darken",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Fotter />

      {/* Skeleton animation style */}
      <style>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.4; }
          100% { opacity: 1; }
        }
      `}</style>
    </>
  );
}
